import { log } from "aframe";
import React, { useRef, useEffect, useState } from "react";

declare const window: any;

function HotspotsSVG({
  colors,
  theme,
  active,
  frame,
  hotspotsUrl,
  originalWidth,
  originalHeight,
  setSubMenuSelected,
  setSubMenuSelectedTemp,
  setMenuSelected,
  menuSelected,
  setFrame,
  details,
  showTextHotspots,
}: any) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  const [hotspotsData, setHotspotsData]: any = React.useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [currentRadius, setCurrentRadius]: any = useState(5);
  const [decreasing, setDecreasing] = useState(false);
  const [isHidden, setIsHidden] = React.useState(true);
  const [isAnimation, setIsAnimation] = React.useState(true);
  React.useEffect(() => {
    if (active === "active") {
      setIsHidden(true);
      setIsAnimation(true);
      setTimeout(() => {
        setIsHidden(false);
      }, 500);
    }
  }, [active]);
  /* useEffect(() => {
    // Esta función se ejecutará cada 65 milisegundos
    const interval = setInterval(() => {
      // Actualizar el estado basado en el estado anterior
      setCurrentRadius((prevRadius) => {
        if (prevRadius + 1 <= 15 && !decreasing) {
          return prevRadius + 1;
        } else if (prevRadius - 1 >= 5 && decreasing) {
          return prevRadius - 1;
        }
        // Cambiar la dirección de la animación
        setDecreasing((prevDecreasing) => !prevDecreasing);
        return prevRadius; // No cambia el radio si no se cumple ninguna condición
      });
    }, 65);

    // Devolver una función de limpieza para detener el intervalo
    return () => clearInterval(interval);
  }, [decreasing]); */

  React.useEffect(() => {
    if (menuSelected === "" || menuSelected === "Inmuebles") {
      setIsAnimation(true);
    }
  }, [menuSelected]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${window.hybrid ? "./" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/" }${hotspotsUrl}`
        );
        const data = await response.json();
        setHotspotsData(data.hotspots_coord_file);
      } catch (error) {
        console.error("Error al cargar los datos:", error);
      }
    };

    fetchData();

    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [hotspotsUrl]);

  useEffect(() => {
    const svg = svgRef.current;
    if (!svg) return;
  
    // Limpiar el contenido del SVG
    svg.innerHTML = "";
  
    // Función para hacer el color más oscuro
    const darkenColor = (color, percent) => {
      const f = parseInt(color.slice(1), 16);
      const t = percent < 0 ? 0 : 255;
      const p = percent < 0 ? percent * -1 : percent;
      const R = f >> 16;
      const G = (f >> 8) & 0x00ff;
      const B = f & 0x0000ff;
      return (
        "#" +
        (
          0x1000000 +
          (Math.round((t - R) * p) + R) * 0x10000 +
          (Math.round((t - G) * p) + G) * 0x100 +
          (Math.round((t - B) * p) + B)
        )
          .toString(16)
          .slice(1)
      );
    };
  
    // Definir el color de hover
    const hoverColor = darkenColor(colors?.main_buttons, -0.2); // Ajusta el 0.2 según la cantidad de contraste que desees
  
    // Dibujar hotspots
    hotspotsData[
      hotspotsData.findIndex((indexFrame) => indexFrame.frame === frame)
    ]?.hotspots.map((hotspot) => {
      const adjustedX = hotspot.verts[0];
      const adjustedY = hotspot.verts[1];
  
      // Crear y añadir un contenedor para el texto
      const textContainer = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "g"
      );
  
      // Crear el texto "Torre"
      const text = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "text"
      );
  
      function calculateTextDimensions(
        text,
        fontSize = "14px",
        fontFamily = "Montserrat"
      ) {
        // Crear un elemento temporal
        const tempElement = document.createElement("div");
  
        // Establecer el texto y los estilos del elemento
        tempElement.style.fontSize = fontSize;
        tempElement.style.fontFamily = fontFamily;
        tempElement.style.position = "absolute";
        tempElement.style.visibility = "hidden";
        tempElement.style.whiteSpace = "nowrap"; // Asegura que el texto no se divida en varias líneas
        tempElement.textContent = text;
  
        // Añadir el elemento al documento para obtener las dimensiones
        document.body.appendChild(tempElement);
  
        // Obtener las dimensiones del texto
        const width = tempElement.offsetWidth;
        const height = tempElement.offsetHeight;
  
        // Eliminar el elemento temporal del documento
        document.body.removeChild(tempElement);
  
        return { width, height };
      }
  
      // Definir la función handleClick antes de usarla
      const handleClick = () => {
        console.log((details?.find((e) => e.group === hotspot.id)));
        
        if ((details?.find((e) => e.group === hotspot.id))?.spin) {
          setMenuSelected("Inmuebles");
          //setFrame(1);
           setSubMenuSelected(hotspot.id);
          setSubMenuSelectedTemp(hotspot.id)
        }
      };
  
      textContainer.setAttribute("cursor", "pointer");
      textContainer.setAttribute(
        "class",
        isAnimation && !isHidden ? "g animation" : !isAnimation && !isHidden ? "g show" : "g"
      );
      textContainer.setAttribute("pointer-events", "visiblefill");
      textContainer.addEventListener("click", handleClick);
  
      if (showTextHotspots) {
        text.setAttribute("x", `${adjustedX}`);
        text.setAttribute(
          "y",
          `${
            adjustedY -
            (window.functionIsPortrait() && window.functionIsMobileDevice()
              ? 120
              : 40)
          }`
        ); // 40 píxeles por encima del círculo
        text.setAttribute("text-anchor", "middle"); // Centrar el texto horizontalmente
        text.setAttribute("fill", colors?.secondary_text); // Cambiar el color del texto a blanco
        text.setAttribute("cursor", "pointer"); // Agregar cursor: pointer al texto
        text.setAttribute("pointer-events", "visiblefill");
        text.setAttribute(
          "font-size",
          window.functionIsPortrait() && window.functionIsMobileDevice()
            ? "2.25rem"
            : "0.875rem"
        );
        text.setAttribute("font-weight", "600");
        text.textContent = hotspot.id
          .replace(/\d+/g, (match) => ` ${match} `)
          .split(/(?=[A-Z])/)
          .join(" ");
        text.addEventListener("click", handleClick);
  
        // Crear y añadir un rectángulo como fondo azul para el texto
        const rect = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "rect"
        );
        const textDimensions = calculateTextDimensions(text.textContent, "18px", "Montserrat");
        const textDimensionsMoviil = calculateTextDimensions(text.textContent, "40px", "Montserrat");
        rect.setAttribute(
          "x",
          `${
            adjustedX -
            (window.functionIsPortrait() && window.functionIsMobileDevice()
              ? textDimensionsMoviil.width < 300 ? 150 : textDimensionsMoviil.width / 2
              : textDimensions.width < 100 ? 50 : textDimensions.width / 2)
          }`
        ); // 50 de margen a la izquierda y derecha del texto
        rect.setAttribute(
          "y",
          `${
            adjustedY -
            (window.functionIsPortrait() && window.functionIsMobileDevice()
              ? 180
              : 60)
          }`
        ); // 60 de margen encima del texto
        rect.setAttribute(
          "width",
          window.functionIsPortrait() && window.functionIsMobileDevice()
            ? textDimensionsMoviil.width < 300 ? "300" :  textDimensionsMoviil.width.toString()
            : textDimensions.width < 100 ? "100" : textDimensions.width.toString()
        );
        rect.setAttribute(
          "height",
          window.functionIsPortrait() && window.functionIsMobileDevice()
            ? "90"
            : "30"
        ); // Altura suficiente para el texto
        rect.setAttribute("fill", colors?.main_buttons);
        rect.setAttribute("cursor", "pointer");
        rect.setAttribute("pointer-events", "visiblefill");
        rect.setAttribute(
          "rx",
          window.functionIsPortrait() && window.functionIsMobileDevice()
            ? "3rem"
            : "1rem"
        ); // Border-radius horizontal
  
        // Añadir eventos de mouse para cambiar el color en hover
        textContainer.addEventListener("mouseover", () => {
          rect.setAttribute("fill", hoverColor);
        });
  
        textContainer.addEventListener("mouseout", () => {
          rect.setAttribute("fill", colors?.main_buttons);
        });
  
        // Asignar el manejador de eventos
        rect.addEventListener("click", handleClick);
  
        // Agregar el rectángulo al contenedor
        textContainer.appendChild(rect);
  
        // Agregar el texto al contenedor
        textContainer.appendChild(text);
      }
  
      // Crear y añadir un círculo al SVG
      const circle = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "circle"
      );
      circle.setAttribute("cx", `${adjustedX}`);
      circle.setAttribute(
        "cy",
        `${
          adjustedY -
          (window.functionIsPortrait() && window.functionIsMobileDevice()
            ? 40
            : 0)
        }`
      );
      circle.setAttribute("r", "8");
      circle.setAttribute("fill", "rgba(255,255,255,0)");
      circle.setAttribute("stroke", "rgba(255,255,255,1)");
      circle.setAttribute("fill-rule", "evenodd");
      circle.setAttribute("stroke-width", "3");
      circle.setAttribute("cursor", "pointer");
      circle.setAttribute("pointer-events", "visiblefill");
      circle.setAttribute("class", "scaling-circle");
  
      // Asignar el manejador de eventos
      circle.addEventListener("click", handleClick);
  
      // Añadir el círculo al contenedor
      textContainer.appendChild(circle);
  
      // Añadir el contenedor al SVG
      svg.appendChild(textContainer);
      setIsAnimation(false);
    });
  }, [
    hotspotsData,
    showTextHotspots,
    screenWidth,
    screenHeight,
    frame,
    isHidden,
  ]);
  

  return (
    <svg
      ref={svgRef}
      width={screenWidth}
      height={screenHeight}
      preserveAspectRatio="xMidYMid slice"
      viewBox={`0 0 ${originalWidth} ${originalHeight}`}
      style={{
        overflow: "hidden",
        pointerEvents: "none",
        position: "absolute",
        cursor: "pointer",
        top: 0,
      }}
    ></svg>
  );
}

export default HotspotsSVG;
